import { render, staticRenderFns } from "./FormingPriceData.vue?vue&type=template&id=f65ea0dc&scoped=true"
import script from "./FormingPriceData.vue?vue&type=script&lang=js"
export * from "./FormingPriceData.vue?vue&type=script&lang=js"
import style0 from "./FormingPriceData.vue?vue&type=style&index=0&id=f65ea0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65ea0dc",
  null
  
)

export default component.exports